import classNames from "classnames";

export const wrapper = classNames(
    // Mobile
    "mobile:pt-8",
    // Tablet
    "tablet:pt-16",
    "tablet:bg-[url(/assets/images/backgrounds/shipping-x.svg)]",
    "tablet:bg-no-repeat",
    "tablet:bg-[position:right_+16px]",
    // All
    // "bg-[url(/assets/images/backgrounds/shipping-x.svg)]",
    // "bg-no-repeat",
    // "bg-[position:right_+16px]",
    "mr-3.5",
    "pb-8"
);
